
const _ = require('lodash');
const $ = require('rgs-jquery');


require('with-global-jquery')(function () {
	require('bootstrap-toggle/js/bootstrap-toggle.js');
});


const Toggle = $.fn.bootstrapToggle.Constructor;
const Plugin = $.fn.bootstrapToggle;


_.extend(Toggle.DEFAULTS, {
	on: 'да',
	off: 'нет',
});

// TODO: this monkey-patch should be replaced with inheritance
// as it's done in other "extended" plugins (tooltip, popover, etc.)

Toggle.prototype.render = function () {
	// This is a rewrite of the default `render` method but
	// with all '.btn' and computed sizes removed

	this._onstyle = '';
	this._offstyle = '';
	const $toggleOn = $('<label>').html(this.options.on);
	const $toggleOff = $('<label>').html(this.options.off);
	const $toggleHandle = $('<span class="toggle-handle">');
	const $toggleGroup = $('<div class="toggle-group">')
		.append($toggleOn, $toggleOff, $toggleHandle);
	const $toggle = $('<div class="toggle" data-toggle="toggle">')
		.addClass(this.$element.prop('checked') ? '' : 'off' )
		.addClass(this.options.style);

	this.$element.wrap($toggle);
	$.extend(this, {
		$toggle: this.$element.parent(),
		$toggleOn: $toggleOn,
		$toggleOff: $toggleOff,
		$toggleGroup: $toggleGroup,
	});
	this.$toggle.append($toggleGroup);

	$toggleOn.addClass('toggle-on');
	$toggleOff.addClass('toggle-off');
	this.update(true);
	this.trigger(true);
};

// Default bsToggle implementation doesn't allow to switch toggle while control is disabled
// Toggle must be editable by changing observable value.
// Nontheless, swithcing from UI will be locked via overriding of 'trigger' func beneath
Toggle.prototype.on = function (silent) {
	this.$toggle.removeClass(this._offstyle + ' off').addClass(this._onstyle);
	this.$element.prop('checked', true);

	if (!silent) {
		this.trigger();
	}
};

Toggle.prototype.off = function (silent) {
	this.$toggle.removeClass(this._onstyle).addClass(this._offstyle + ' off');
	this.$element.prop('checked', false);

	if (!silent) {
		this.trigger();
	}
};

Toggle.prototype.toggle = function () {
	if (this.$element.prop('disabled')) {
		return;
	}

	if (this.$element.prop('checked')) {
		this.off();
	} else {
		this.on();
	}
};

module.exports = Plugin;

